@if (!isPluginMode()) {
  <mat-toolbar class="header">
    <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
    {{ data.title }}
    </div>
  </mat-toolbar>
}

<div [ngClass]="{'dialog-wrapper': !isPluginMode()}" >
  <div #wrapper>

    @if (!isPluginMode()) {
      <div class="form-row">
        <mat-form-field class="field">
          <mat-label>Origen</mat-label>
          <mat-select [(ngModel)]="selectedSourceDocumentType" (ngModelChange)="onSourceTypeChange()" required>
            @for(sourceDocumentType of SOURCE_DOCUMENT_TYPES; track sourceDocumentType) {
              <mat-option [value]="sourceDocumentType">
                {{ sourceDocumentType | human }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <form [formGroup]="form">

      @if (!isPluginMode() && form.get('source_document_id') && selectedSourceDocumentType() && !isInvoiceMode) {
        <div class="form-row">
          <mat-form-field class="field" [floatLabel]="'always'">
            <mat-label>{{ selectedSourceDocumentType() | human }}</mat-label>
            <input type="text"
             placeholder="Busca {{ selectedSourceDocumentType() | human }} por Nº"
             aria-label="Number"
             matInput
             formControlName="source_document_id"
             [matAutocomplete]="auto">
             <span matTextPrefix>#&nbsp;</span>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDocumentFn">
              @for(document of sourceDocuments(); track document.id) {
                <mat-option [value]="document">
                  {{ document.correlative_id }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }

      @if(loading()) {
        <div class="loading">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      } @else {
        @if (selectedSourceDocument() || isInvoiceMode) {

          @if (!isMovementMode) {
            <!-- Invoice Form Fields -->
            <ng-container formGroupName="invoice">
              <div class="form-row">
                <mat-form-field class="field">
                  <mat-label>Proveedor</mat-label>
                  <mat-select formControlName="stakeholder_id">
                    <button type="button" mat-button (click)="addProvider()">Agregar Nuevo Proveedor</button>
                    @for (provider of providers(); track provider.id) {
                      <mat-option [value]="provider.id">
                        {{ provider.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Fecha de Pago</mat-label>
                  <input matInput [matDatepicker]="due_date" formControlName="due_date">
                  <mat-datepicker-toggle matSuffix [for]="due_date"></mat-datepicker-toggle>
                  <mat-datepicker #due_date [startAt]=""></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="field">
                  <mat-label>Tipo de documento tributario</mat-label>
                  <mat-select formControlName="invoice_type">
                    @for (invoiceType of invoiceTypes; track invoiceType) {
                      <mat-option [value]="invoiceType">
                        {{ invoiceType | human }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              @if (!isReadOnly()) {
                <div class="form-row">
                  <button type="button" mat-raised-button (click)="fileInput.click()">
                    @if (loading()) {
                      <mat-spinner diameter="20"></mat-spinner>
                      Adjuntando {{'Invoice' | human}}
                    } 
                    @else if (form.get('invoice.url').value) {
                      <ng-container>
                        <mat-icon>check</mat-icon>
                        Archivo Adjuntado
                      </ng-container>
                    } 
                    @else {
                      <ng-container>
                        <mat-icon>attach_file</mat-icon>
                        Adjuntar {{'Invoice' | human}}
                      </ng-container>
                    }
                  </button>
                  <input hidden #fileInput type="file" (change)="uploadInvoiceFile($event)">
                </div>
              }
            </ng-container>
          }

          <div class="form-row">
            <mat-form-field class="field">
              <mat-label>Bodega</mat-label>
              <mat-select formControlName="warehouse_id" required>
                @for (warehouse of warehouses$ | async; track warehouse.id) {
                  <mat-option [value]="warehouse.id">
                    {{ warehouse.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
    
          @if (inventoriableCategoriesIds) {
            <div>
              <app-inventory-action-form
                [parentFormGroup]="(form | formGroup)"
                [compareTo]="isInvoiceMode ? null: selectedSourceDocument()"
                [enableAmount]="showTotals"
                [enableDiscounts]="false"
                [filterCategories]="inventoriableCategoriesIds"
                [isReadOnly]="isReadOnly()"
                [onlyInventoriable]="true"
                [sellMode]="false"
                [showBuyPrice]="true"
                [showTotals]="showTotals"
                (dataChanged)="updated.emit()"
              >
              </app-inventory-action-form>
            </div>
          }
        }
      }
    </form>
  </div>
</div>

@if (!isPluginMode()) {
  <mat-toolbar class="footer">
    <button mat-raised-button mat-dialog-close> 
      Cancelar
    </button>
    <div class="expander"></div>
    <button mat-raised-button
            type="button"
            color="primary"
            [disabled]="!formValid || loading()"
            (click)="saveForm()">
      @if (loading()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        Crear/Iniciar
      }
          </button>
  </mat-toolbar>
}
